import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { useAddTerritorialUnitsMutation, useDeleteTerritorialUnitsMutation, useEditTerritorialUnitsMutation } from "../../../../redux/api/handBooksApi/territorialUnitsApi";
import { EntTerritorialsUnits } from "../../../../models/handBooks/territorialsUnits";
import { getCookie } from "typescript-cookie";

const useTerritorialUnit = (modal: any, refresh?: () => void) => {
    const { t } = useTranslation()
    const { confirm } = modal;
    const [addTerritorialUnit] = useAddTerritorialUnitsMutation(); // Обновлено
    const [deleteTerritorialUnit] = useDeleteTerritorialUnitsMutation(); // Обновлено
    const [editTerritorialUnit] = useEditTerritorialUnitsMutation(); // Обновлено

    async function onAddTerritorialUnit(newTerritorialUnit: EntTerritorialsUnits): Promise<boolean> { // Обновлено
        try {
            let status: boolean = false;
            await addTerritorialUnit(newTerritorialUnit).then((response: any) => {
                 if (response.error) {
                                             const isKyrgyz = getCookie('i18next') === 'ky';
                                             const lang = isKyrgyz ? 'kg' : 'ru';
                                             const res = response.error.data?.res;
                                             const errorMessages = Array.isArray(res)
                                                 ? res.map((error: any) => error[lang] || error.ru).join('\n')
                                                 : response.error.data?.msg || t('unknownError'); 
                                             throw new Error(errorMessages);
                                         }
                if (response.data.success) {
                    status = true;
                    message.success(t('msg.successAdd'));
                    if (refresh) refresh();
                }
            }).catch((error: any) => {
                modal.error({ title: t('msg.error'), content: String(error.message) });
            });
            return status;
        } catch (error: any) {
            modal.error({ title: t('msg.error'), content: String(error.message) });
            return false;
        }
    }

    async function onDeleteTerritorialUnit(territorialUnit: EntTerritorialsUnits) { // Обновлено
        try {
            let status: boolean = false;
            confirm({
                centered: true,
                title: t('msg.confirmDeleteText'),
                okText: t('general.yes'),
                cancelText: t('general.no'),
                onOk() {
                    deleteTerritorialUnit(territorialUnit.id as number).then((response: any) => {
                        if (response.error !== undefined && response.error.status === 400) {
                            status = false;
                            throw new Error(response.error.data.message);
                        }
                        if (response.data.success) {
                            status = true;
                            Modal.success({ title: t('msg.successDelete') });
                            if (refresh) refresh();
                        }
                    }).catch((error: any) => {
                        Modal.error({ title: t('msg.error'), content: String(error.message) });
                    });
                }
            })
            return status;
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };

    async function onEditTerritorialUnit(editedTerritorialUnit: EntTerritorialsUnits): Promise<boolean> { // Обновлено
        try {
            let status: boolean = false;
            await editTerritorialUnit(editedTerritorialUnit).then((response: any) => {
                if (response.error) {
                    const isKyrgyz = getCookie('i18next') === 'ky';
                    const lang = isKyrgyz ? 'kg' : 'ru';
                    const res = response.error.data?.res;
                    const errorMessages = Array.isArray(res)
                        ? res.map((error: any) => error[lang] || error.ru).join('\n')
                        : response.error.data?.msg || t('unknownError'); 
                    throw new Error(errorMessages);
                }
                if (response.data.success) {
                    status = true;
                    Modal.success({ title: t('msg.successEdited') });
                    if (refresh) refresh();
                }
            }).catch((error: any) => {
                Modal.error({ title: t('msg.error'), content: String(error.message) });
            });
            return status;
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };

    return { onAddTerritorialUnit, onDeleteTerritorialUnit, onEditTerritorialUnit }
}

export { useTerritorialUnit };
